<template>
  <v-container fluid class="px-5">
    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <!-- SNACKBAR -->

    <v-dialog v-model="dialog" persistent max-width="550px">
      <v-card>
        <v-form ref="fhorariosEmpleado">
          <v-card-title class="px-4 py-6">
            <span class="text-h5 px-4">Asignacion de Horario</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row class="px-6">
                <v-col cols="12" class="px-1 pt-0 ma-0">
                  <v-autocomplete
                    v-model="selected.horarioId"
                    :items="horarios"
                    label="Horarios"
                    item-text="horario"
                    item-value="id"
                    :rules="requiredRule"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="px-1 pt-0 ma-0">
                  <v-autocomplete
                    v-model="selected.empleadoId"
                    :items="empleados"
                    :filter="empleadosFilter"
                    label="Empleado"
                    item-text="nombre"
                    item-value="id"
                    :rules="requiredRule"
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.validoDesde"
                    label="Valido Desde"
                    type="datetime-local"
                    :rules="requiredRule"
                    dense
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0 px-1 ma-0">
                  <v-text-field
                    v-model.trim="selected.validoHasta"
                    label="Valido Hasta"
                    type="datetime-local"
                    :rules="requiredRule"
                    dense
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-7 pb-4 pt-0">
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text outlined @click="limpiar">
              Cerrar
            </v-btn>
            <v-btn color="blue darken-1" dark @click="guardar"> Guardar </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-row justify="space-between" align="center">
      <v-col cols="12">
        <h2 class="px-3">Asignación de Horarios Empleado</h2>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row align="center" justify="center" class="pt-4 pb-1">
      <v-spacer></v-spacer>

      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaInicio"
          type="date"
          hide-details
          dense
          label="Inicio"
          clearable
        ></v-text-field>
      </v-col>
      <v-col class="pt-0" cols="12" md="2">
        <v-text-field
          v-model="fechaFin"
          type="date"
          dense
          hide-details
          label="Fin"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="1" class="text-right pt-0">
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="primary"
              dark
              :block="$vuetify.breakpoint.smAndDown"
              @click="listar"
            >
              Listar
            </v-btn>
          </template>
          <span>Listar</span>
        </v-tooltip>
      </v-col>
      <v-col class="pt-0" cols="12" md="1">
        <v-tooltip bottom color="success">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              color="green"
              :block="$vuetify.breakpoint.smAndDown"
              dark
              @click="downloadReporte"
            >
              <v-icon>fas fa-file-download</v-icon>
            </v-btn>
          </template>
          <span>Descargar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-divider></v-divider>
    <v-row>
      <v-col cols="12">
        <v-stepper non-linear v-model="step">
          <v-stepper-header>
            <v-stepper-step editable step="1">
              Horarios Empleado</v-stepper-step
            >
            <v-divider></v-divider>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-row>
                <v-col class="pt-0 pl-4" cols="12" md="4">
                  <v-text-field
                    class="text-xs-center"
                    v-model="search"
                    dense
                    append-icon="search"
                    label="Búsqueda"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" class="pt-0 pl-4">
                  <v-btn
                    class="mx-2"
                    dark
                    color="primary"
                    @click="dialog = true"
                  >
                    Agregar
                    <v-icon dark small class="pl-1"> fa-plus </v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headerGeneral"
                :items="horariosEmpleado"
                :loading="loader"
                loading-text="Listando Datos..."
                no-data-text="No se encontraron resultados..."
                :search="search"
                class="elevation-2"
              >
                <template v-slot:[`item.opciones`]="{ item }">
                  <v-tooltip left color="primary" dark>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        @click="verDetallesHorarios(item)"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                      >
                        fas fa-calendar-week
                      </v-icon>
                    </template>
                    <span>Ver Detalles Horario</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.validoDesde`]="{ item }">
                  {{ formatDate(item.validoDesde) }}
                </template>
                <template v-slot:[`item.validoHasta`]="{ item }">
                  {{ formatDate(item.validoHasta) }}
                </template>
              </v-data-table>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import XLSX from "xlsx";
import moment from "moment";

export default {
  name: "HorariosEmpleado",
  data() {
    return {
      step: 1,
      snack: false,
      requiredRule: [(v) => (v && !/\s/.test(v)) || "Campo obligatorio"],
      fechaInicio: new Date().toISOString().substr(0, 10),
      fechaFin: new Date().toISOString().substr(0, 10),
      selected: {
        horarioEmpleadoId: null,
        horarioId: null,
        empleadoId: null,
        validoDesde: null,
        validoHasta: null,
      },
      empleados: [],
      horarios: [],
      dialog: false,
      snackColor: "primary",
      snackTime: 6500,
      snackText: "Notification",
      horariosEmpleado: [],
      loader: false,
      search: "",
      headerGeneral: [
        {
          text: "Empleado",
          value: "empleadoNombre",
          align: "center",
          width: 350,
          sortable: true,
        },
        {
          text: "Horario",
          value: "horarioNombre",
          align: "center",
          width: 350,
          sortable: true,
        },
        {
          text: "Valido Desde",
          value: "validoDesde",
          align: "center",
          width: 150,
          sortable: true,
        },
        {
          text: "Valido Hasta",
          value: "validoHasta",
          align: "center",
          width: 150,
          sortable: true,
        },
        {
          text: "Opciones",
          value: "opciones",
          align: "center",
          sortable: false,
          width: 100,
        },
      ],
    };
  },
  created() {
    if (this.$store.state.permisos) {
      const tienePermiso = this.$store.state.permisos.some(
        (permiso) =>
          permiso.nombre_modulo == "Marcaciones" ||
          permiso.nombre_modulo == "Horarios Empleado"
      );

      if (!tienePermiso) {
        this.$router.go(-1);
      }

      this.listarComboBox();
      this.listar();
    } else {
      location.reload(true);
    }
  },
  computed: {},
  methods: {
    verDetallesHorarios(item) {
      const routeData = this.$router.resolve({
        path: `Horario/${item.horarioId}`,
      });
      window.open(routeData.href, "_blank");
    },
    empleadosFilter(item, queryText, itemText) {
      // Convertir a minúsculas para búsqueda case insensitive
      const nombreMatch = item.nombre
        .toLowerCase()
        .includes(queryText.toLowerCase());

      // Búsqueda por código (número)
      const codigoMatch =
        // Si el query es numérico, comparar con el código
        (!isNaN(queryText) && item.codigo === Number(queryText)) ||
        // O también comparar como string por si el usuario escribe "32"
        item.codigo.toString().includes(queryText);

      return nombreMatch || codigoMatch;
    },
    listarComboBox() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get("api/Marcaciones/Employee/CBB", configuracion)
        .then((res) => {
          this.empleados = res.data;
        })
        .catch((err) => {
          console.error(err);
        });

      axios
        .get("api/Marcaciones/Horarios/CBB", configuracion)
        .then((res) => {
          this.horarios = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    formatDate(fecha) {
      if (fecha == null) return "- - - -";
      if (!fecha || typeof fecha != "string") {
        throw new Error(
          "El parametro 'fecha' debe ser de tipo String y no puede estar vacio"
        );
      }

      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
    nuevo() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fhorariosEmpleado.validate()) {
        axios
          .post("api/Marcaciones/HorarioEmpleado", this.selected, configuracion)
          .then((res) => {
            this.snackText = "Nuevo Registro Creado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Crear El Registro";
            if (err.response.status == 400 || err.response.status == 404) {
              this.snackText = err.response.data;
            }

            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    actualizar() {
      return;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (this.$refs.fhorariosEmpleado.validate()) {
        axios
          .put(
            `api/Marcaciones/HorarioEmpleado/${this.selected.horarioEmpleadoId}`,
            this.selected,
            configuracion
          )
          .then((res) => {
            this.snackText = "Registro Actualizado!";
            this.snackColor = "primary";
            this.snack = true;

            this.limpiar();
            this.listar();
          })
          .catch((err) => {
            console.error(err);

            this.snackText = "No se Pudo Actualizar el Registro";
            if (err.response.status == 400 || err.response.status == 404) {
              this.snackText = err.response.data;
            } else {
              this.snackText = "No se Pudo Actualizar el Registro";
            }

            this.snackColor = "error";
            this.snack = true;
          });
      } else {
        this.snackText = "Complete los Campos Necesarios";
        this.snackColor = "error";
        this.snack = true;
      }
    },
    guardar() {
      if (!this.selected?.horarioEmpleadoId) {
        this.nuevo();
      } else {
        // this.actualizar();
      }
    },
    limpiar() {
      this.selected = {
        horarioEmpleadoId: null,
        horarioId: null,
        empleadoId: null,
        validoDesde: null,
        validoHasta: null,
      };

      this.dialog = false;

      if (this.$refs.fhorariosEmpleado) {
        this.$refs.fhorariosEmpleado.resetValidation();
      }
    },
    verDetalles(item) {
      this.selected = { ...item };
      this.dialog = true;
    },
    listar() {
      this.loader = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          `api/Marcaciones/HorarioEmpleado?inicio=${this.fechaInicio}&fin=${this.fechaFin}`,
          configuracion
        )
        .then((res) => {
          this.horariosEmpleado = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => (this.loader = false));
    },
    downloadReporte() {
      const workbook = XLSX.utils.book_new();

      const data = XLSX.utils.json_to_sheet(this.horariosEmpleado);
      XLSX.utils.book_append_sheet(workbook, data, "horariosEmpleado");

      const filename = "horariosEmpleado.xlsx";
      XLSX.writeFile(workbook, filename);
    },
  },
};
</script>
